import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Login from "./auth/login";

// MUI Theme Provider
import { ThemeProvider, createTheme, CssBaseline, GlobalStyles } from "@mui/material";
import * as colors from '@mui/material/colors';
import { ColorModeContext } from "./ColorModeContext";

// MUI Elements
import {Box, Button} from "@mui/material"
import { ReactComponent as Logo } from './dashboard/logo.svg'
import { ReactComponent as HPP } from './dashboard/hpp.svg'
import { FlashlightOff, FlashlightOn } from "@mui/icons-material";

// Create a light/dark theme configuration
const lightTheme = createTheme({
    palette: {
      mode: 'light',
      background:{
        default: colors.grey[50]
      } ,
      primary: {
        main: colors.blue[800]
      },
      secondary:{
        main: colors.grey[700]
      },
    
    },
    typography:{
      fontFamily: 'arial, helvetica, sans-derif',
      h3:{
          color:'red',
        },
    }
  });

  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: colors.blue[800]
      },
      secondary:{
        main: colors.grey[700]
      },
  
  
    },
    typography:{
      fontFamily: 'arial, helvetica, sans-derif',
      h3:{
          color:'red',
        },
    }
  });
  

const RootComponent = () => {
  const [authenticated, setAuthenticated] = useState(true);
  const [colorMode, setColorMode] = useState(true);
  const handleColorMode = () => {
    setColorMode(prev => !prev);
  };

  return (
    <ColorModeContext.Provider value={{ colorMode }}>
    <ThemeProvider theme={colorMode ? darkTheme : lightTheme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          '::-webkit-scrollbar': {
            width: '12px',
            height: '12px',
          },
          '::-webkit-scrollbar-thumb': {
            backgroundColor: colorMode ? colors.grey[800] : colors.grey[400], 
            borderRadius: '10px',
          },
          '::-webkit-scrollbar-track': {
            backgroundColor: colorMode ? '#2d2d2d' : '#f0f0f0', 
            borderRadius: '10px',
          },
        }}
      />
      <Box sx={{height:'7vh', marginBottom:'10px', padding:0, backgroundColor: colorMode? colors.grey[900] : colors.blueGrey[900] }}> 
        <div style={{flex: "1", display: "flex", flexDirection:"row", alignContent: "center"}}>
        <h1 style={{ fontFamily:"helvetica", margin:"1vh 0px auto 10px", fontSize:'4vh', color:colorMode?colors.grey[50]:colors.grey[50]} }> VIZZ...</h1>
        <Logo style={{height:"4vh", margin:"1.5vh 10px 0px 5px", fill:colorMode?colors.grey[50]:colors.grey[50]} }/>
        <HPP style={{height:"4vh", margin:"10px 10px 0px auto", fillRule:"evenodd", fill:colorMode?colors.grey[50]:colors.grey[50]}}/>
        <Box >
        <Button onClick={handleColorMode} style={{height:"100%"}}>
            {colorMode ? <FlashlightOff sx={{color:colors.grey[50]}}/> : <FlashlightOn sx={{color:colors.grey[50]}}/>}
        </Button>
        </Box>
        </div>
      </Box>
      {authenticated ? 
      <App /> 
      : 
      <Login onAuthenticate={() => setAuthenticated(true)} />}
    <Box sx={{height:'3.6vv', fontSize:"1.5vh", marginTop:'10px', paddingTop:'1vh', backgroundColor:colorMode?colors.grey[900]:colors.blueGrey[900]}  }>
      <Box sx={{display:"flex"}}>
      <div style={{flex:1, textAlign:"left", marginLeft:"10px", textDecoration:"none"}}><a href="https://hpp.coyocloud.com/workspaces/wettbewerb/apps/wiki/tutorials/list/view/5d35c4af-3918-4945-890b-73d1888b6215" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "white" }}>Credits and legal info</a></div>
      <div style={{flex:1, textAlign:"center", color:'white' }}><a href="https://www.hpp.com/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "white" }}>HPP</a> Vizz © 2025 </div>
      <div style={{flex:1, textAlign:"right", marginRight:"10px", textDecoration:"none"}}><a href="https://hpp.coyocloud.com/workspaces/wettbewerb/apps/wiki/tutorials/list/view/5d35c4af-3918-4945-890b-73d1888b6215" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "white" }}> ⓘ Contact for help and questions</a></div>  
      </Box>
    </Box>
    </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(<RootComponent />);

// Performance measuring
reportWebVitals();
